import React from "react";

const StoryContinue: React.FC = () => {
  return (
    <section className="hobstory-section">
      <div className="hobstory-container">
        <span className="hobstory-label">THE STORY CONTINUES</span>

        <h2 className="hobstory-title">
          House of Bombay is still being written.
        </h2>

        <p className="hobstory-description">
          Every service, every gathering, every shared meal adds another chapter
          to the story. Follow along for new menus, city stories,
          behind-the-scenes moments, and glimpses into the culture that inspires
          this house.
        </p>

        <a
          href="https://www.instagram.com/houseofbombaynj/"
          target="_blank"
          rel="noopener noreferrer"
          className="hobstory-link"
        >
          FOLLOW @HOUSEOFBOMBAYNJ
          <span className="hobstory-arrow">↗</span>
        </a>
      </div>
    </section>
  );
};

export default StoryContinue;
